import { Component, OnInit } from '@angular/core';
import { ModalLoginService } from '../../services/modal-login.service';

@Component({
  selector: 'app-modal-page',
  templateUrl: './modal-page.component.html',
  styleUrls: ['./modal-page.component.css']
})
export class ModalPageComponent implements OnInit {

  constructor(private modalLoginSrv: ModalLoginService) { }

  ngOnInit(): void {
    this.modalLoginSrv.openModalLogin();
  }

}
